import {
    addDays,
    addHours,
    getDate,
    getDay,
    getMonth,
    getYear,
    isAfter,
    OwaDate,
    owaDate,
    startOfDay,
    startOfHour,
} from 'owa-datetime';
import DayOfWeek from 'owa-service/lib/contract/DayOfWeek';

const hourOffsetRegular = 8;
const hourOffsetLater = 3;
const hourOffsetEvening = 18;
const hourOffsetWeekend = 10;

// Schedule 3 hours into future
export function laterDate(date: OwaDate) {
    return addHours(startOfHour(date), hourOffsetLater);
}

// Schedule for evening
export function eveningDate(date: OwaDate) {
    return addHours(startOfDay(date), hourOffsetEvening);
}

// Schedule for tomorrow
export function tomorrowDate(date: OwaDate) {
    return addHours(addDays(startOfDay(date), 1), hourOffsetRegular);
}

// Schedule for weekend (next saturday)
export function weekendDate(date: OwaDate) {
    return getNextDay(date, DayOfWeek.Saturday, hourOffsetWeekend);
}

// Schedule for next week (next monday)
export function firstWeekdayDate(date: OwaDate) {
    let nextWeekday = getNextDay(date, DayOfWeek.Monday, hourOffsetRegular);

    // This avoids the condition where we schedule on monday and wrap around to
    // the same monday (today), so we must add 7 to get next week's start.
    if (isAfter(date, nextWeekday)) {
        nextWeekday = addDays(nextWeekday, 7);
    }
    return nextWeekday;
}

// Calculate the next day that satisfies offset
export function getNextDay(date: OwaDate, dow: number, hour: number) {
    return owaDate(
        date.tz,
        getYear(date),
        getMonth(date),
        getDate(date) + ((dow + (7 - getDay(date))) % 7),
        hour
    );
}
